import React, { useContext, useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../Context/AuthProvider";
import {
  compareDates,
  convertUTCToTimeZone,
  convertUTCToTimeZoneDateTimeString,
} from "../Utility/DateTimeUtility";
import {
  AppointmentStatus,
  BillingStatus,
  ServiceStatus,
} from "../Utility/Constants";
import { formatAge } from "../Utility/Utility";
import HeaderValueDisplay from "../common/HeaderValueDisplay";
import { Badge, Cake, Wc, Phone, Email } from "@mui/icons-material";
import { Modal, Toast } from "bootstrap";
import { getDisplayValue, showLoadingImage } from "../Utility/Utility";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ConfirmationDialog from "../common/ConfirmationDialog";
import MenuBar from "../common/MenuBar";
import "../index.css";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Divider,
  Fab,
  Grid2,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { getLinkedServices, removeService } from "../API/LinkedServicesApi";
import {
  CloseOutlined,
  DeleteOutlineRounded,
  DisabledByDefault,
  EditOutlined,
  EventNoteOutlined,
  Person,
  PostAdd,
} from "@mui/icons-material";
//import AddNewServiceDialog from "../Services/AddNewServiceDialog";
import dayjs from "dayjs";
import { useSnackbar } from "../Utility/UserMessageContext";
import { getBillById } from "../API/BillingApi";
import { getBillByVisitId } from "../API/BillingApi";
import { getBillByVisitorId } from "../API/BillingApi";
import { getVisitById } from "../API/VisitsApi";

function AppointmentDetails({
  selectedVisitId,
  onEditBill,
  onViewPatientDetails,
  onViewWorklistDetails,
  onViewPrescription,
    onAddServices,
  onViewDocument, 
  onEditVisit,
  onSavePrescription
}) {
  const [selectedVisit, setSelectedVisit] = useState();
  const { auth } = useContext(AuthContext);
  // const [prescriptions, setPrescriptions] = useState();
  // const [newStatus, setNewStatus] = useState();
  // const [errorMessage, setErrorMessage] = useState();
  // const errorToast = new Toast(document.getElementById("errorToast"));
  const [linkedServices, setLinkedServices] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [openStatusChangeDialog, setOpenStatusChangeDialog] = useState(false);
  const [pendingStatusChange, setPendingStatusChange] = useState(null);

  // const checkInPatientModalId = "checkIn" + selectedVisitId;
  // const [currentPrescription, setCurrentPrescription] = useState();
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [currentRow, setCurrentRow] = useState(null);
  //const [prescriptionIdToBeEdited, setPrescriptionIdToBeEdited] = useState();
  //const [keyForRescheduleRendering, setKeyForRescheduleRendering] = useState(0);
  const [openAddServiceDialog, setOpenAddServiceDialog] = useState();
  const [billDetails, setBillDetails] = useState(null);

  const [billAmountSummary, setBillAmountSummary] = useState({
    totalAmount: 0,
    paidAmount: 0,
    refundedAmount: 0,
    balanceAmount: 0,
  });

  const { showSnackbar } = useSnackbar();
  // Check if the screen is small (sm) or extra small (xs)
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setCurrentRow(null);
  };

  // const loadBillingData = useCallback(async () => {
  //   // Ensure you handle the valid billId or newBillInfo.id
  //   const currentBillId = selectedAppointment?.billId;

  //   if (!currentBillId) {
  //     setLoading(false);
  //     console.warn("No valid Bill ID to fetch billing data.");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const result = await getBillById(auth, currentBillId);

  //     if (result.isSuccess) {
  //       const data = result.data;
  //       setBillDetails({
  //         billNo: data.displayId || "N/A",
  //         createdBy: data.createdByUserName || "N/A",
  //         createdOn: data.createdOn || "N/A",
  //         billId: data.id || "N/A",
  //       });

  //       const updatedSummary = {
  //         totalAmount: data.totalAmount ?? 0,
  //         paidAmount: data.paidAmount ?? 0,
  //         refundedAmount: data.totalRefundedAmount ?? 0,
  //         balanceAmount: data.balanceAmount ?? 0,
  //       };
  //       setBillAmountSummary(updatedSummary);
  //     } else {
  //       setError("Failed to load billing details");
  //       console.error("API call failed:", result.data);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching billing details", error);
  //     setError("Error fetching billing details");
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [auth, selectedAppointment?.billId]);
  // Fix for loadBillingData function - around line 97

const loadBillingData = useCallback(async () => {
  const visitId = selectedVisitId;

  if (!visitId) {
    console.warn("No valid Visit ID to fetch billing data.");
    return;
  }

  setLoading(true);
  try {
    const result = await getBillByVisitorId(auth, visitId);
    console.log("getBillByVisitorId FULL RESPONSE:", JSON.stringify(result, null, 2));

    if (result.isSuccess) {
      const data = result.data;
      setBillDetails({
        billNo: data.displayId || "N/A",
        createdBy: data.createdByUserName || "N/A",
        createdOn: data.createdOn || "N/A",
        billId: data.id || "N/A",
      });

      const updatedSummary = {
        totalAmount: data.totalAmount ?? 0,
        paidAmount: data.paidAmount ?? 0,
        refundedAmount: data.refundedAmount ?? 0,
        balanceAmount: data.balanceAmount ?? 0,
      };
      setBillAmountSummary(updatedSummary);
    } else {
      // No bill exists
      console.error("API call failed:", result);
      setBillDetails(null); // Set to null when no bill exists
      setError("Failed to load billing details");
    }
  } catch (error) {
    console.error("Error fetching billing details", error);
    setBillDetails(null); // Set to null on error
    setError("Error fetching billing details");
  } finally {
    setLoading(false);
  }
}, [auth, selectedVisitId]);

const handleAddServices = () => {
  if (onAddServices) {
    onAddServices({
      id: selectedVisitId,
      displayId: selectedVisit?.displayId,
    });
  }
};

  // Fix for JSX rendering - find these lines around line 930-940 and update:
  // Change this:
  //   value={`Rs ${billAmountSummary.refundedAmount.toFixed(2)}`}
  // To this:
  //   value={`Rs ${(billAmountSummary?.refundedAmount ?? 0).toFixed(2)}`}
  const handleCheckIn = () => {
    setPendingStatusChange(AppointmentStatus.CheckedIn);
    setOpenStatusChangeDialog(true);
  };

  const handleCancelVisit = () => {
    setPendingStatusChange(AppointmentStatus.Cancelled);
    setOpenStatusChangeDialog(true);
  };

 // Around line 278 - Update the handleCompleteVisit function
// Around line 278 - Update the handleCompleteVisit function
// Around line 278 - Update the handleCompleteVisit function
const handleCompleteVisit = () => {
  // Allow completing visit regardless of service status
  setPendingStatusChange(AppointmentStatus.Completed);
  setOpenStatusChangeDialog(true);
};

  const handleNoShow = () => {
    setPendingStatusChange(AppointmentStatus.NoShow);
    setOpenStatusChangeDialog(true);
  };

  const handleReschedule = () => {
    if (onEditVisit) {
      onEditVisit(selectedVisit);
    }
  };

  const confirmStatusChange = async () => {
    if (!pendingStatusChange || !selectedVisit?.id) return;

    try {
      const { updateAppointmentStatus } =
        await import("../API/AppointmentsApi");
      const result = await updateAppointmentStatus(
        auth,
        selectedVisit.id,
        pendingStatusChange,
      );

      if (result?.isSuccess) {
        // Refresh visit details
        const updatedVisit = await getVisitById(
          auth,
          selectedVisitId,
          auth?.selectedFacility?.id,
        );
        if (updatedVisit?.isSuccess) {
          setSelectedVisit(updatedVisit?.data);
          showSnackbar("Visit status updated successfully", "success");
        }
      } else {
        showSnackbar(result?.data || "Failed to update visit status", "error");
      }
    } catch (error) {
      console.error("Error updating visit status:", error);
      showSnackbar("Error updating visit status", "error");
    } finally {
      setOpenStatusChangeDialog(false);
      setPendingStatusChange(null);
    }
  };

  // Helper function to check if visit is today
  const isVisitToday = () => {
    if (!selectedVisit?.appointmentDateTime) return false;

    const visitDate = convertUTCToTimeZone(
      selectedVisit.appointmentDateTime,
      auth?.selectedFacility?.timeZone,
    ).format("YYYY-MM-DD");

    return visitDate === dayjs().format("YYYY-MM-DD");
  };

  // Helper function to check if visit date has passed
  const isVisitPast = () => {
    if (!selectedVisit?.appointmentDateTime) return false;

    return convertUTCToTimeZone(
      selectedVisit.appointmentDateTime,
      auth?.selectedFacility?.timeZone,
    ).isBefore(dayjs());
  };

 // serviceGridColumns array me changes - around line 365
const serviceGridColumns = [
  {
    field: "displayId",
    headerName: "ID",
    width: 150,
    renderCell: (params) => (
      <span
        style={{
          textDecoration: "underline",
          cursor: "pointer",
          fontWeight: params.row.isPrimary ? "bold" : "normal",
        }}
        onClick={() =>
          onViewWorklistDetails &&
          onViewWorklistDetails({
            id: params.row.id,
            displayId: params.row.displayId,
          })
        }
      >
        {params.row.displayId}
      </span>
    ),
  },
  { 
    field: "serviceCode", 
    headerName: "Code", 
    width: 80,
    renderCell: (params) => (
      <span style={{ fontWeight: params.row.isPrimary ? "bold" : "normal" }}>
        {params.row.serviceCode}
      </span>
    ),
  },
  { 
    field: "serviceName", 
    headerName: "Name", 
    width: 150,
    renderCell: (params) => (
      <span style={{ fontWeight: params.row.isPrimary ? "bold" : "normal" }}>
        {params.row.serviceName}
      </span>
    ),
  },
  {
    field: "assignedTo",
    headerName: "Assigned To",
    width: 200,
    renderCell: (params) => (
      <span style={{ fontWeight: params.row.isPrimary ? "bold" : "normal" }}>
        {params?.row?.assignedToUserName
          ? params?.row?.assignedToUserName
          : "Not Assigned"}
      </span>
    ),
  },
  {
    field: "status",
    headerName: "Status",
    width: 100,
    renderCell: (params) => (
      <span style={{ fontWeight: params.row.isPrimary ? "bold" : "normal" }}>
        {getDisplayValue(params?.row?.status)}
      </span>
    ),
  },
  {
    field: "scheduledStartDateTime",
    headerName: "Scheduled Date Time",
    width: 180,
    renderCell: (params) => (
      <span style={{ fontWeight: params.row.isPrimary ? "bold" : "normal" }}>
        {convertUTCToTimeZoneDateTimeString(
          params?.row?.scheduledStartDateTime,
          auth?.selectedFacility?.timeZone,
        )}
      </span>
    ),
  },
  {
    field: "actualStartDateTime",
    headerName: "Start Date Time",
    width: 180,
    renderCell: (params) => (
      <span style={{ fontWeight: params.row.isPrimary ? "bold" : "normal" }}>
        {convertUTCToTimeZoneDateTimeString(
          params?.row?.actualStartDateTime,
          auth?.selectedFacility?.timeZone,
        )}
      </span>
    ),
  },
  {
    field: "actualEndDateTime",
    headerName: "Completion Time",
    width: 180,
    renderCell: (params) => (
      <span style={{ fontWeight: params.row.isPrimary ? "bold" : "normal" }}>
        {convertUTCToTimeZoneDateTimeString(
          params?.row?.actualEndDateTime,
          auth?.selectedFacility?.timeZone,
        )}
      </span>
    ),
  },
  {
    field: "billId",
    headerName: "Bill",
    width: 180,
    renderCell: (params) => {
      const billStatus = params.row.billingStatus === "AddedToBill" || params.row.billId
        ? "Added to bill"
        : billDetails?.billId && 
          params.row.isPrimary && 
          billDetails.billId && 
          Math.abs((billAmountSummary?.totalAmount ?? 0) - (params.row.fees * (1 - (params.row.discountInPercentage || 0) / 100))) < 0.01
        ? "Added to bill"
        : "Not added to bill";
      
      return (
        <span style={{ fontWeight: params.row.isPrimary ? "bold" : "normal" }}>
          {billStatus}
        </span>
      );
    },
  },
];

  useEffect(() => {
    const loadVisitDetails = async () => {
      const visitDetailsResult = await getVisitById(
        auth,
        selectedVisitId,
        auth?.selectedFacility?.id,
      );
      if (visitDetailsResult?.isSuccess) {
        console.log("Visit Details API Response:", visitDetailsResult?.data);
        setSelectedVisit(visitDetailsResult?.data);
      } else {
        showSnackbar("Failed to load visit details", "error");
      }
    };
 // loadLinkedServices function me sorting add karo - around line 629
const loadLinkedServices = async () => {
  const result = await getLinkedServices(auth, selectedVisitId);
  if (result?.isSuccess) {
    console.log(
      "linkedServices FULL ARRAY:",
      JSON.stringify(result?.data, null, 2),
    );
    if (result?.data && result?.data.length > 0) {
      console.log(
        "FIRST SERVICE OBJECT:",
        JSON.stringify(result?.data[0], null, 2),
      );
      console.log("Service billingStatus values:", result?.data.map(s => s.billingStatus));
      console.log("Service billId values:", result?.data.map(s => s.billId));
    }
    
    // Sort services: primary first, then by creation date
    const sortedServices = result?.data?.sort((a, b) => {
      // Primary service always first
      if (a.isPrimary && !b.isPrimary) return -1;
      if (!a.isPrimary && b.isPrimary) return 1;
      
      // If both are primary or both are not, sort by scheduledStartDateTime
      return new Date(a.scheduledStartDateTime) - new Date(b.scheduledStartDateTime);
    });
    
    setLinkedServices(sortedServices);
  } else {
    // error if the services are not loaded.
  }
};
    loadVisitDetails();
    loadLinkedServices();
  }, [selectedVisitId, auth]);
  useEffect(() => {
    if (selectedVisitId) {
      loadBillingData();
    }
  }, [loadBillingData, selectedVisitId]);

  const refreshServiceList = async () => {
    const result = await getLinkedServices(auth, selectedVisitId);
    if (result?.isSuccess) {
      setLinkedServices(result?.data);
    }
  };

  const onServiceRemove = async (item) => {
    if (item.status !== ServiceStatus.NotStarted) {
      showSnackbar(
        "Service cannot be removed as it is already started or completed.",
        "error",
      );
      return;
    } else {
      const result = await removeService(auth, item.id);
      if (result?.isSuccess) {
        refreshServiceList();
      }
    }
  };

  // Render service cards for mobile view
  const renderServiceCards = () => {
    if (!linkedServices || linkedServices.length === 0) {
      return <Typography variant="body2">No services found</Typography>;
    }

    return linkedServices.map((service) => (
      <Card key={service.id} variant="outlined" sx={{ mb: 2, borderRadius: 2 }}>
        <CardHeader
          title={<Box sx={{ mt: 1 }}></Box>}
          subheader={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="caption" sx={{ fontWeight: "bold" }}>
                {service.displayId}
              </Typography>
              <Chip
                label={getDisplayValue(service.status)}
                size="small"
                color={
                  service.status === ServiceStatus.Completed
                    ? "success"
                    : service.status === ServiceStatus.InProgress
                      ? "primary"
                      : service.status === ServiceStatus.NotStarted
                        ? "default"
                        : "error"
                }
              />
            </Box>
          }
          action={
            <Box sx={{ display: "flex", gap: 1 }}>
              {service?.billingStatus === "NotBilled" && (
                <Tooltip title="Add to Bill - yet to be implemented" arrow>
                  <IconButton
                    size="small"
                    sx={{
                      bgcolor: "action.hover",
                      "&:hover": { bgcolor: "action.selected" },
                    }}
                  >
                    <PostAdd fontSize="small" color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
              {service?.billingStatus === "AddedToBill" && (
                <Tooltip title="Remove from Bill - yet to be implemented" arrow>
                  <IconButton
                    size="small"
                    sx={{
                      bgcolor: "action.hover",
                      "&:hover": { bgcolor: "action.selected" },
                    }}
                  >
                    <DisabledByDefault fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              {service?.status === ServiceStatus.NotStarted &&
                !service?.isPrimary && (
                  <Tooltip title="Remove" arrow>
                    <IconButton
                      size="small"
                      onClick={() => onServiceRemove(service)}
                      sx={{
                        bgcolor: "action.hover",
                        "&:hover": { bgcolor: "action.selected" },
                      }}
                    >
                      <CloseOutlined fontSize="small" sx={{ color: "#000" }} />
                    </IconButton>
                  </Tooltip>
                )}
            </Box>
          }
        />
        <CardContent sx={{ pt: 0 }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontSize: "0.9rem",
              fontWeight: "500",
              whiteSpace: "normal",
              wordBreak: "break-word",
              mb: 2,
              fontWeight: "bold",
            }}
          >
            {service.serviceName}
          </Typography>
        </CardContent>
        <Divider />
        <CardContent>
          <Stack spacing={1}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Code:</Typography>
              <Typography variant="body2">{service.serviceCode}</Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Assigned To:</Typography>
              <Typography variant="body2">
                {service?.assignedToUserName
                  ? service.assignedToUserName
                  : "Not Assigned"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Scheduled:</Typography>
              <Typography variant="body2">
                {service?.scheduledDateTime
                  ? convertUTCToTimeZone(
                      service?.scheduledDateTime,
                      auth?.selectedFacility?.timeZone,
                    ).format("DD-MMM-YYYY hh:mm A")
                  : "Not scheduled"}
              </Typography>
            </Box>

            {service?.startDateTime && (
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Started:</Typography>
                <Typography variant="body2">
                  {convertUTCToTimeZone(
                    service?.startDateTime,
                    auth?.selectedFacility?.timeZone,
                  ).format("DD-MMM-YYYY hh:mm A")}
                </Typography>
              </Box>
            )}

            {service?.completionTime && (
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Completed:</Typography>
                <Typography variant="body2">
                  {convertUTCToTimeZone(
                    service?.completionTime,
                    auth?.selectedFacility?.timeZone,
                  ).format("DD-MMM-YYYY hh:mm A")}
                </Typography>
              </Box>
            )}

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Bill:</Typography>
              <Typography variant="body2">
                {service?.billingStatus === "AddedToBill"
                  ? "Added to bill"
                  : "Not added to bill"}
              </Typography>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    ));
  };
  //  const handleFetchVisitDetails = async (visitId) => {
  //   try {
  //     console.log("Fetching visit details:", visitId);
  //     const result = await getVisitByFacility(auth, visitId, auth?.selectedFacility?.id);

  //     console.log("API Result:", result);

  //     if (result?.isSuccess && result?.data) {
  //       console.log("Visit data loaded:", result.data);
  //       return result.data;
  //     } else {
  //       showSnackbar(result?.data || "Failed to load visit details", "error");
  //       return null;
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     showSnackbar("Error loading visit details", "error");
  //     return null;
  //   }
  // };

  const renderPatientDetailsCard = () => {
    return (
      <Card variant="outlined" sx={{ mb: 2, borderRadius: 2, width: "100%" }}>
        <CardContent sx={{ padding: 2 }}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            mb={1}
            color="text.secondary"
          >
            Patient's Details
          </Typography>

          <Divider sx={{ my: 1 }} />

          {/* Patient details section - now takes full width */}
          <Box sx={{ width: "100%" }}>
            <Box sx={{ "& > div": { mb: 1 } }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Name:</Typography>
                <Typography variant="body2">
                  <Link to="/patient" state={selectedVisit?.patientId}>
                    {selectedVisit?.patientFirstName}&nbsp;
                    {selectedVisit?.patientLastName}
                  </Link>
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">MRN:</Typography>
                <Typography variant="body2">
                  {selectedVisit?.patientMRN || "-"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Age:</Typography>
                <Typography variant="body2">
                  {formatAge(selectedVisit?.patientAgeInYears)}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Gender:</Typography>
                <Typography variant="body2">
                  {selectedVisit?.patientGender || "-"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Mobile:</Typography>
                <Typography variant="body2" sx={{ overflowWrap: "break-word" }}>
                  {selectedVisit?.patientMobileNo || "-"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Email:</Typography>
                <Typography variant="body2" sx={{ overflowWrap: "break-word" }}>
                  {selectedVisit?.patientEmailId || "-"}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Photo section - moved below the details */}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <img
              src={
                selectedVisit?.patient?.photo
                  ? selectedVisit?.patient?.photo
                  : selectedVisit?.patient?.gender === "Male"
                    ? "./placeholder-image-male-gender.webp"
                    : "./placeholder-image-female-gender.webp"
              }
              className="border rounded p-0"
              alt="PatientPhoto"
              width="80"
              height="80"
            />
          </Box>
        </CardContent>
      </Card>
    );
  };

  // Render visit details card for mobile view
  const renderVisitDetailsCard = () => {
    return (
      <Card variant="outlined" sx={{ mb: 2, borderRadius: 2, width: "100%" }}>
        <CardContent sx={{ padding: 2 }}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            mb={1}
            color="text.secondary"
          >
            Visit Details
          </Typography>

          <Divider sx={{ my: 1 }} />

          <Box sx={{ "& > div": { mb: 1 } }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Status:</Typography>
              <Typography variant="body2">
                {selectedVisit?.visitStatus || "-"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Referred By:</Typography>
              <Typography variant="body2">{selectedVisit?.referredBy || "-"}</Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Scheduled At:</Typography>
              <Typography variant="body2">
                {dayjs(selectedVisit?.appointmentDateTime).format(
                  "ddd, DD-MMM-YYYY, hh:mm A",
                )}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Booked By:</Typography>
              <Typography variant="body2">
                {selectedVisit?.createdByUserName || "-"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Time of Booking:</Typography>
              <Typography variant="body2">
                {convertUTCToTimeZoneDateTimeString(
                  selectedVisit?.createdOn,
                  auth?.selectedFacility?.timeZone,
                ) || "-"}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  };

  // Render primary service card for mobile view
  const renderPrimaryServiceCard = () => {
    return (
      <Card variant="outlined" sx={{ mb: 2, borderRadius: 2, width: "100%" }}>
        <CardContent sx={{ padding: 2 }}>
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            mb={1}
            color="text.secondary"
          >
            Primary Service Scheduled With
          </Typography>

          <Divider sx={{ my: 1 }} />

          <Box sx={{ "& > div": { mb: 1 } }}>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Name:</Typography>
              <Typography variant="body2">
                {selectedVisit?.physicianPrefix}&nbsp;
                {selectedVisit?.physicianFirstName}&nbsp;
                {selectedVisit?.physicianLastName}&nbsp;
                {selectedVisit?.physicianSuffix
                  ? `, ${selectedVisit.physicianSuffix}`
                  : ""}
              </Typography>
            </Box>

            {/* <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">ID:</Typography>
              <Typography variant="body2">
                {selectedVisit?.physicianProfessionalId || "-"}
              </Typography>
            </Box> */}

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Mobile:</Typography>
              <Typography variant="body2">
                {selectedVisit?.physicianMobileNo || "-"}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="body2">Email:</Typography>
              <Typography variant="body2">
                {selectedVisit?.physicianEmailId || "-"}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    );
  };

 return (
  <>
    {/* Sticky MenuBar */}
    <Grid2
      container
      size={12}
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1100,
        backgroundColor: "white",
      }}
    >
      <Grid2 size={12}>
        <MenuBar
          showEdit={
            selectedVisit?.visitStatus === AppointmentStatus.Cancelled ||
            selectedVisit?.visitStatus === AppointmentStatus.CheckedIn ||
            selectedVisit?.visitStatus === AppointmentStatus.Scheduled
          }
          onEdit={handleReschedule}
          editLabel="Reschedule"
          editTooltip="Reschedule Visit"
          showCheckIn={
            selectedVisit?.visitStatus === AppointmentStatus.Scheduled &&
            isVisitToday()
          }
          onCheckIn={handleCheckIn}
          checkInLabel="Check In"
          checkInTooltip="Check In Patient"
          showCancel={
            selectedVisit?.visitStatus === AppointmentStatus.Scheduled ||
            selectedVisit?.visitStatus === AppointmentStatus.CheckedIn
          }
          onCancel={handleCancelVisit}
          cancelLabel="Cancel"
          cancelTooltip="Cancel Visit"
          showAddServices={
            selectedVisit?.visitStatus === AppointmentStatus.Scheduled ||
            selectedVisit?.visitStatus === AppointmentStatus.CheckedIn ||
            selectedVisit?.visitStatus === AppointmentStatus.InProgress
          }
          onAddServices={handleAddServices}
          showFinalize={
            selectedVisit?.visitStatus === AppointmentStatus.InProgress
          }
          onFinalize={handleCompleteVisit}
          finalizeLabel="Complete"
          finalizeTooltip="Complete Visit"
          finalizeDisabled={false}
          showNoShow={
            selectedVisit?.visitStatus === AppointmentStatus.Scheduled &&
            isVisitPast()
          }
          onNoShow={handleNoShow}
          noShowLabel="No Show"
          noShowTooltip="Mark as No Show"
          disabled={false}
        />
      </Grid2>
    </Grid2>

    {/* Scrollable Content */}
    <Grid2
      container
      spacing={1}
      sx={{
        paddingX: "5px",
        paddingTop: "5px",
        paddingBottom: "50px",
        maxHeight: "calc(100vh - 150px)",
        overflowY: "auto",
      }}
    >
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(216, 214, 214, 0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1301,
          }}
        >
          {showLoadingImage()}
        </div>
      )}
        <Grid2 container size={12} sx={{ paddingX: "5px" }}>
          <Grid2 container size={12} sx={{ paddingX: "5px" }}>
            {isSmallScreen ? (
              // Mobile view layout using cards
              <Grid2 container size={12} sx={{ px: 1 }}>
                {renderPatientDetailsCard()}
                {renderVisitDetailsCard()}
                {renderPrimaryServiceCard()}
              </Grid2>
            ) : (
              // Desktop view layout - unchanged

              <Grid2 container size={12}>
                <Grid2 container size={12}>
                  <Grid2 size={12}>
                    <Card
                      className="outerCard"
                      variant="outlined"
                      sx={{
                        padding: "4px",
                        pointerEvents: loading ? "none" : "auto",
                        opacity: loading ? 0.6 : 1,
                        width: "100%",
                      }}
                    >
                      <Grid2 container size={12}>
                        {/* Patient's Details Section - Single Row */}
                        <Grid2 size={12}>
                          <Typography variant="body1" color="text.secondary">
                            Patient's Details
                          </Typography>
                          <Grid2
                            container
                            size={12}
                            sx={{ alignItems: "center" }}
                          >
                            {/* Patient Name */}
                            <Grid2 size={1.7}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <Person fontSize="small" />
                                {/* <Link
                                  to="/patient"
                                  state={selectedAppointment?.patientId}
                                >
                                  {selectedAppointment?.patientFirstName}{" "}
                                  {selectedAppointment?.patientLastName}
                                </Link> */}
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    onViewPatientDetails &&
                                    onViewPatientDetails({
                                      id: selectedVisit?.patientId,
                                      firstName:
                                        selectedVisit?.patientFirstName,
                                      lastName: selectedVisit?.patientLastName,
                                    })
                                  }
                                >
                                  {selectedVisit?.patientFirstName}{" "}
                                  {selectedVisit?.patientLastName}
                                </span>
                              </Box>
                            </Grid2>

                            {/* MRN */}
                            <Grid2 size={2}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <Badge fontSize="small" />
                                <Typography
                                  variant="body2"
                                  sx={{ whiteSpace: "nowrap" }}
                                >
                                  {selectedVisit?.patientMRN || "N/A"}
                                </Typography>
                              </Box>
                            </Grid2>

                            {/* Age */}
                            <Grid2 size={1.6}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <Cake fontSize="small" />
                                <Typography
                                  variant="body2"
                                  sx={{ whiteSpace: "nowrap" }}
                                >
                                  {formatAge(selectedVisit?.patientAgeInYears)}
                                </Typography>
                              </Box>
                            </Grid2>

                            {/* Gender */}
                            <Grid2 size={1.5}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <Wc fontSize="small" />
                                <Typography
                                  variant="body2"
                                  sx={{ whiteSpace: "nowrap" }}
                                >
                                  {selectedVisit?.patientGender || "N/A"}
                                </Typography>
                              </Box>
                            </Grid2>

                            {/* Contact */}
                            <Grid2 size={1.8}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <Phone fontSize="small" />
                                <Typography
                                  variant="body2"
                                  sx={{ whiteSpace: "nowrap" }}
                                >
                                  {selectedVisit?.patientMobileNo || "N/A"}
                                </Typography>
                              </Box>
                            </Grid2>

                            {/* Email */}
                            <Grid2 size={2.4}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 0.5,
                                }}
                              >
                                <Email fontSize="small" />
                                <Typography
                                  variant="body2"
                                  sx={{
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "100%",
                                  }}
                                >
                                  {selectedVisit?.patientEmailId || "N/A"}
                                </Typography>
                              </Box>
                            </Grid2>

                            {/* Patient Photo */}
                            <Grid2 size={1}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  height: "100%",
                                  justifyContent: "center",
                                  mt: -2,
                                }}
                              >
                                <img
                                  src={
                                    selectedVisit?.patient?.photo
                                      ? selectedVisit?.patient?.photo
                                      : selectedVisit?.patientGender === "Male"
                                        ? "./placeholder-image-male-gender.webp"
                                        : "./placeholder-image-female-gender.webp"
                                  }
                                  className="border rounded p-0"
                                  alt="PatientPhoto"
                                  width="50"
                                  height="50"
                                  style={{ objectFit: "cover" }}
                                />
                              </Box>
                            </Grid2>
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    </Card>
                  </Grid2>
                </Grid2>
                <Grid2 size={12}>
                  <Card
                    className="outerCard"
                    variant="outlined"
                    sx={{
                      padding: "16px",
                      pointerEvents: loading ? "none" : "auto",
                      opacity: loading ? 0.6 : 1,
                      width: "100%",
                    }}
                  >
                    <Grid2 container size={12}>
                      {/* Visit Details Section - New Line */}
                      <Grid2 size={12}>
                        <Typography variant="body1" color="text.secondary">
                          Visit Details
                        </Typography>
                        <Grid2 container size={12} spacing={2}>
                          <Grid2
                            size={{ xs: 12, sm: 6, md: 4, lg: 2.4, xl: 2.4 }}
                          >
                            <HeaderValueDisplay
                              header="Status"
                              value={selectedVisit?.visitStatus || "N/A"}
                            />
                          </Grid2>
                          <Grid2
                            size={{ xs: 12, sm: 6, md: 4, lg: 2.4, xl: 2.4 }}
                          >
                            <HeaderValueDisplay
                              header="Referred By"
                              value={selectedVisit?.referredBy || "-"}
                            />
                          </Grid2>
                          <Grid2
                            size={{ xs: 12, sm: 6, md: 4, lg: 2.4, xl: 2.4 }}
                          >
                            <HeaderValueDisplay
                              header="Scheduled At"
                              value={dayjs(
                                selectedVisit?.appointmentDateTime,
                              ).format("ddd, DD-MMM-YYYY, hh:mm A")}
                            />
                          </Grid2>
                          <Grid2
                            size={{ xs: 12, sm: 6, md: 4, lg: 2.4, xl: 2.4 }}
                          >
                            <HeaderValueDisplay
                              header="Booked By"
                              value={selectedVisit?.createdByUserName || "N/A"}
                            />
                          </Grid2>
                          <Grid2
                            size={{ xs: 12, sm: 6, md: 4, lg: 2.4, xl: 2.4 }}
                          >
                            <HeaderValueDisplay
                              header="Time of Booking"
                              value={
                                convertUTCToTimeZoneDateTimeString(
                                  selectedVisit?.createdOn,
                                  auth?.selectedFacility?.timeZone,
                                ) || "-"
                              }
                            />
                          </Grid2>
                        </Grid2>
                      </Grid2>

                      {/* Primary Service Scheduled With Section - New Line */}
                      <Grid2 size={12}>
                        <Typography variant="body1" color="text.secondary">
                          Primary Service Scheduled With
                        </Typography>
                        <Grid2 container size={12} spacing={2}>
                          <Grid2
                            size={{ xs: 12, sm: 6, md: 4, lg: 2.4, xl: 2.4 }}
                          >
                            <HeaderValueDisplay
                              header="Name"
                              value={`${selectedVisit?.physicianPrefix || ""} ${
                                selectedVisit?.physicianFirstName || ""
                              } ${
                                selectedVisit?.physicianLastName || ""
                              }                ${
                                selectedVisit?.physicianSuffix
                                  ? `, ${selectedVisit.physicianSuffix}`
                                  : ""
                              }

                              `.trim()}
                            />
                          </Grid2>
                          {/* <Grid2
                            size={{ xs: 12, sm: 6, md: 4, lg: 2.4, xl: 2.4 }}
                          >
                            <HeaderValueDisplay
                              header="ID"
                              value={
                                selectedVisit?.physicianProfessionalId || "N/A"
                              }
                            />
                          </Grid2> */}
                          <Grid2
                            size={{ xs: 12, sm: 6, md: 4, lg: 2.4, xl: 2.4 }}
                          >
                            <HeaderValueDisplay
                              header="Mobile"
                              value={selectedVisit?.physicianMobileNo || "N/A"}
                            />
                          </Grid2>
                          <Grid2
                            size={{ xs: 12, sm: 6, md: 4, lg: 2.4, xl: 2.4 }}
                          >
                            <HeaderValueDisplay
                              header="Email"
                              value={selectedVisit?.physicianEmailId || "N/A"}
                            />
                          </Grid2>
                          <Grid2
                            size={{ xs: 12, sm: 6, md: 4, lg: 2.4, xl: 2.4 }}
                          >
                            {/* Empty space for alignment */}
                          </Grid2>
                        </Grid2>
                      </Grid2>

                      {/*Advance payment*/}
                      <Grid2 size={12} sx={{ mt: 2 }}>
                        <Typography variant="body1" color="text.secondary">
                          Billing Information
                        </Typography>
                        <Grid2 container size={12} spacing={2}>
                          {/* Check if bill exists */}
                          {!billDetails?.billNo ? (
                            <Grid2 size={12}>
                              <HeaderValueDisplay
                                header="Bill Status"
                                value="No bill exists for this visit"
                              />
                            </Grid2>
                          ) : (
                            <>
                              <Grid2
                                size={{
                                  xs: 12,
                                  sm: 6,
                                  md: 4,
                                  lg: 2.4,
                                  xl: 2.4,
                                }}
                              >
                                {/* <HeaderValueDisplay
                                  header="Bill No"
                                  value={
                                    billDetails?.billNo ? (
                                      <Link
                                        to="/newbill"
                                        state={{ billId: billDetails?.billId }}
                                      >
                                        {billDetails.billNo}
                                      </Link>
                                    ) : (
                                      "N/A"
                                    )
                                  }
                                /> */}
                                <HeaderValueDisplay
                                  header="Bill No"
                                  value={
                                    billDetails?.billNo ? (
                                      <span
                                        style={{
                                          textDecoration: "underline",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          onEditBill &&
                                          onEditBill({
                                            id: billDetails?.billId,
                                            displayId: billDetails?.billNo,
                                            patientName: `${selectedVisit?.patientFirstName} ${selectedVisit?.patientLastName}`,
                                          })
                                        }
                                      >
                                        {billDetails.billNo}
                                      </span>
                                    ) : (
                                      "N/A"
                                    )
                                  }
                                />
                              </Grid2>
                              {/* <Grid2
          size={{ xs: 12, sm: 6, md: 4, lg: 2.4, xl: 2.4 }}
        >
          <HeaderValueDisplay
            header="Advance Payment"
            value={selectedAppointment?.advanceAmount || "N/A"}
          />
        </Grid2> */}
                              <Grid2
                                size={{
                                  xs: 12,
                                  sm: 6,
                                  md: 4,
                                  lg: 2.4,
                                  xl: 2.4,
                                }}
                              >
                                <HeaderValueDisplay
                                  header="Total Billed Amount"
                                  value={`Rs ${(
                                    billAmountSummary?.totalAmount +
                                    (parseFloat(selectedVisit?.advanceAmount) ||
                                      0)
                                  ).toFixed(2)}`}
                                />
                              </Grid2>
                              <Grid2
                                size={{
                                  xs: 12,
                                  sm: 6,
                                  md: 4,
                                  lg: 2.4,
                                  xl: 2.4,
                                }}
                              >
                                <HeaderValueDisplay
                                  header="Total Paid Amount"
                                  value={`Rs ${(
                                    billAmountSummary?.paidAmount ?? 0
                                  ).toFixed(2)}`}
                                />
                              </Grid2>
                              <Grid2
                                size={{
                                  xs: 12,
                                  sm: 6,
                                  md: 4,
                                  lg: 2.4,
                                  xl: 2.4,
                                }}
                              >
                                <HeaderValueDisplay
                                  header="Total Refunded Amount"
                                  value={`Rs ${(
                                    billAmountSummary?.refundedAmount ?? 0
                                  ).toFixed(2)}`}
                                />
                              </Grid2>
                              <Grid2
                                size={{
                                  xs: 12,
                                  sm: 6,
                                  md: 4,
                                  lg: 2.4,
                                  xl: 2.4,
                                }}
                              >
                                <HeaderValueDisplay
                                  header="Total Balance"
                                  value={`Rs ${(
                                    billAmountSummary?.balanceAmount ?? 0
                                  ).toFixed(2)}`}
                                />
                              </Grid2>
                            </>
                          )}
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </Card>
                </Grid2>
              </Grid2>
            )}
            <Grid2
              container
              size={12}
              sx={{ height: isSmallScreen ? "auto" : "400px", mt: 2 }}
            >
              <Card variant="outlined" sx={{ width: "100%", height: "100%" }}>
                <CardHeader
                  subheader="Availed Services"
                  subheaderTypographyProps={{
                    fontSize: "14px",
                  }}
                  sx={{ paddingY: "10px" }}
                  action={
                    <Tooltip title="Add new service" arrow>
                      <Fab
                        color="secondary"
                        size="small"
                        onClick={() => setOpenAddServiceDialog(true)}
                        hidden={
                          true
                          // selectedVisit?.visitStatus ===
                          //   AppointmentStatus.Completed ||
                          // selectedVisit?.visitStatus ===
                          //   AppointmentStatus.Cancelled ||
                          // selectedVisit?.visitStatus ===
                          //   AppointmentStatus.NoShow
                        }
                      >
                        <AddRoundedIcon sx={{ padding: "0px" }} />
                      </Fab>
                    </Tooltip>
                  }
                ></CardHeader>
                <CardContent
                  sx={{ border: "1px", height: isSmallScreen ? "auto" : "90%" }}
                >
                  {isSmallScreen ? (
                    // Mobile view - Cards
                    <Box sx={{ maxHeight: "60vh", overflow: "auto", px: 1 }}>
                      {renderServiceCards()}
                    </Box>
                  ) : (
                    // Desktop view - DataGrid
                    <DataGrid
                      sx={{
                        height: "100%",
                        "& .sticky-column": {
                          position: "sticky",
                          right: 0,
                          backgroundColor: "white",
                          zIndex: 100,
                        },
                        "& .MuiTablePagination-toolbar": {
                          minHeight: "unset",
                          alignItems: "center",
                          paddingTop: "0 !important",
                          paddingBottom: "0 !important",
                        },
                        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                          {
                            margin: 0,
                          },
                      }}
                      initialState={{ density: "compact" }}
                      columns={serviceGridColumns}
                      rows={linkedServices}
                    ></DataGrid>
                  )}
                </CardContent>
              </Card>

              {/* <AddNewServiceDialog
                openState={openAddServiceDialog}
                setOpenState={setOpenAddServiceDialog}
                visitId={selectedVisitId}
                refreshServices={refreshServiceList}
                visitType={selectedVisit?.visitType}
                //visitType={selectedVisit?.currentVisitType}
                visitLocation={selectedVisit?.location}
                visitDate={convertUTCToTimeZoneDateTimeString(
                  selectedVisit?.visitDateTime,
                  auth?.selectedFacility?.timeZone
                )}
              ></AddNewServiceDialog> */}
              <ConfirmationDialog
                open={openStatusChangeDialog}
                onClose={() => {
                  setOpenStatusChangeDialog(false);
                  setPendingStatusChange(null);
                }}
                onConfirm={confirmStatusChange}
                title="Confirm Status Change"
                okButtonColor="secondary"
                statement={
                  pendingStatusChange === AppointmentStatus.CheckedIn
                    ? `You are changing the status from ${selectedVisit?.visitStatus} to Checked In. Are you sure?`
                    : pendingStatusChange === AppointmentStatus.Cancelled
                      ? `You are changing the status from ${selectedVisit?.visitStatus} to Cancelled. Are you sure?`
                      : pendingStatusChange === AppointmentStatus.Completed
                        ? `You are changing the status from ${selectedVisit?.visitStatus} to Completed. Are you sure?`
                        : pendingStatusChange === AppointmentStatus.NoShow
                          ? `You are changing the status from ${selectedVisit?.visitStatus} to No Show. Are you sure?`
                          : "Are you sure you want to change the visit status?"
                }
              />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  );
}

export default AppointmentDetails;
